import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Cell } from "react-md";
import { ProductionTimeCard, SummaryCard, AppraiserPerformanceCard } from "components/Shared/TimeLogs";
import AppraiserMacCard from "components/User/Mac/AppraiserMacCard";
import CaseProfile from "containers/Homeowner/CaseProfile/CaseProfile";
import { getTimeLogByDaySummary } from "actions/qualityAssurance";
import { CaseTimeLogWorkTypeEnum } from "interfaces/Mueller.Business.Models.ts";
import {
  getCaseTimeLogByUserPayPeriod,
  updateCaseTimeLog,
  deleteCaseTimeLog,
  addCaseTimeLog,
} from "actions/casetimelog";
import { getPayPeriodStartDate, getPayPeriodEndDate } from "components/EmployeeTimeLogs";

const AppraiserTimeLogDetails = ({
  selectedPayPeriod,
  selectedEmployee,
  getTimeLogByDaySummary,
  timeLogByDaySummary,
  isFetchingTimeLogByDaySummary,
  timeLogs,
  isFetchingTimeLogs,
  getCaseTimeLogByUserPayPeriod,
  updateCaseTimeLog,
  isUpdatingTimeLogs,
  isDeletingTimeLogs,
  deleteCaseTimeLog,
  addCaseTimeLog,
  isAddingTimeLogs,
}) => {
  const [filterDate, setFilterDate] = useState();
  const [refreshSummaryCard, setRefreshSummaryCard] = useState(false);
  const [selectedControlNumber, setSelectedControlNumber] = useState(0);

  useEffect(() => {
    if (refreshSummaryCard) setRefreshSummaryCard(false);
  }, [refreshSummaryCard]);

  const onfilterDateChange = date => setFilterDate(date);
  const onRefreshSummary = () => setRefreshSummaryCard(true);
  const onControlNumberSelected = controlNumber => {
    if (controlNumber !== selectedControlNumber) setSelectedControlNumber(controlNumber);
  };

  const payPeriodStartDate = getPayPeriodStartDate(selectedPayPeriod.fromDate);
  const payPeriodEndDate = getPayPeriodEndDate(selectedPayPeriod.toDate);
  const showCaseProfile = selectedControlNumber > 0;

  return (
    <>
      <Cell size={12} className="employee-timelogs-grid-section-2" style={{ marginTop: 0, paddingTop: 0 }}>
        <SummaryCard
          summary={timeLogByDaySummary}
          filterDateCallBack={onfilterDateChange}
          isFetchingData={isFetchingTimeLogByDaySummary}
          getData={getTimeLogByDaySummary}
          payPeriodId={selectedPayPeriod.id}
          data={timeLogByDaySummary}
          internetUserId={selectedEmployee.internetUserId}
          employeeName={selectedEmployee.name}
          refreshCard={onRefreshSummary}
          isEmployeeTimeLogsView
          isAppraiserEmployeeTimeLogs
        />
      </Cell>
      <Cell size={12}>
        <AppraiserPerformanceCard
          isEditable={true}
          data={timeLogs}
          isFetchingData={isFetchingTimeLogs}
          filterDate={filterDate}
          getData={getCaseTimeLogByUserPayPeriod}
          internetUserId={selectedEmployee.internetUserId}
          payPeriod={selectedPayPeriod}
          startDate={payPeriodStartDate}
          endDate={payPeriodEndDate}
          refreshSummaryCard={onRefreshSummary}
          onControlNumberSelected={onControlNumberSelected}
        />
      </Cell>
      <Cell size={12} className="production-card">
        <ProductionTimeCard
          isEditable={true}
          data={timeLogs}
          isFetchingData={isFetchingTimeLogs}
          filterDate={filterDate}
          update={updateCaseTimeLog}
          getData={getCaseTimeLogByUserPayPeriod}
          isUpdating={isUpdatingTimeLogs}
          isDeleting={isDeletingTimeLogs}
          delete={deleteCaseTimeLog}
          add={addCaseTimeLog}
          internetUserId={selectedEmployee.internetUserId}
          isAdding={isAddingTimeLogs}
          payPeriod={selectedPayPeriod}
          startDate={payPeriodStartDate}
          endDate={payPeriodEndDate}
          refreshSummaryCard={onRefreshSummary}
          workTypeId={CaseTimeLogWorkTypeEnum.VALUATION}
        />
      </Cell>
      <Cell size={12} className="mac-card">
        <AppraiserMacCard
          appraiserNumber={selectedEmployee.number}
          payPeriod={selectedPayPeriod}
          displayFooter={false}
          hidePayPeriodSelection={true}
        />
      </Cell>
      {showCaseProfile &&
        <Cell size={12} tabletSize={12} phoneSize={12} style={{ marginTop: 0, paddingTop: 0 }}>
          <CaseProfile
            controlNumber={selectedControlNumber}
            verticalDisplay={true}
          />
        </Cell>
      }
    </>
  );
};

AppraiserTimeLogDetails.propTypes = {
  selectedPayPeriod: PropTypes.object,
  selectedEmployee: PropTypes.object,
  // Dispatch and State props
  isFetchingTimeLogs: PropTypes.bool.isRequired,
  timeLogs: PropTypes.array.isRequired,
  getCaseTimeLogByUserPayPeriod: PropTypes.func.isRequired,
  updateCaseTimeLog: PropTypes.func.isRequired,
  isUpdatingTimeLogs: PropTypes.bool,
  deleteCaseTimeLog: PropTypes.func.isRequired,
  isDeletingTimeLogs: PropTypes.bool,
  addCaseTimeLog: PropTypes.func.isRequired,
  isAddingTimeLogs: PropTypes.bool,
  timeLogByDaySummary: PropTypes.object.isRequired,
  isFetchingTimeLogByDaySummary: PropTypes.bool.isRequired,
  getTimeLogByDaySummary: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    isFetchingTimeLogs: state.caseTimeLog.isFetchingTimeLogs,
    timeLogs: state.caseTimeLog.timeLogs,
    isUpdatingTimeLogs: state.caseTimeLog.isUpdatingTimeLogs,
    isDeletingTimeLogs: state.caseTimeLog.isDeletingTimeLogs,
    isAddingTimeLogs: state.caseTimeLog.fetching,
    timeLogByDaySummary: state.qualityAssurance.timeLogByDaySummary,
    isFetchingTimeLogByDaySummary: state.qualityAssurance.isFetchingTimeLogByDaySummary,
  };
};

const mapDispatchToProps = dispatch => ({
  getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId) {
    dispatch(getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId));
  },
  updateCaseTimeLog(updatedCaseTimeLog, updateTimeLogFunc) {
    dispatch(updateCaseTimeLog(updatedCaseTimeLog, updateTimeLogFunc));
  },
  deleteCaseTimeLog(id) {
    dispatch(deleteCaseTimeLog(id));
  },
  addCaseTimeLog(dto) {
    dispatch(addCaseTimeLog(dto));
  },
  getTimeLogByDaySummary(internetUserId, payPeriodId) {
    dispatch(getTimeLogByDaySummary(internetUserId, payPeriodId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AppraiserTimeLogDetails);
